import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Calendar } from "lucide-react";

const links = [
  { to: "/", label: "Home", testId: "nav-link-home" },
  { to: "/projects", label: "Projects", testId: "nav-link-projects" },
  { to: "/blog", label: "Blog", testId: "nav-link-blog" },
  { to: "/cv", label: "CV", testId: "nav-link-cv" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors hover:text-stone-900 ${
      isActive ? "text-stone-900 font-semibold" : "text-stone-500"
    }`;

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 bg-[#FDFBF7]/85 backdrop-blur-md border-b border-stone-200/80"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            data-testid="nav-brand-link"
            className="font-heading text-lg font-bold tracking-tight text-stone-900"
            onClick={() => setOpen(false)}
          >
            Abhishek B<span className="text-amber-600">.</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === "/"} className={linkClass} data-testid={link.testId}>
                {link.label}
              </NavLink>
            ))}
            <a
              href="https://topmate.io/bhattacharjee_abhishek"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-book-call-button"
              className="inline-flex items-center gap-2 rounded-full bg-stone-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-stone-700"
            >
              <Calendar className="h-4 w-4" />
              Book a call
            </a>
          </nav>

          <button
            className="md:hidden p-2 text-stone-700"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-menu-button"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {open && (
          <nav className="md:hidden pb-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={linkClass}
                data-testid={`${link.testId}-mobile`}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href="https://topmate.io/bhattacharjee_abhishek"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-book-call-button-mobile"
              className="inline-flex items-center gap-2 text-sm font-semibold text-amber-700"
            >
              <Calendar className="h-4 w-4" />
              Book a call
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
